<template>
  <div v-if="$route.query.optionControlTestMode" class="fixed top-0 z-50 text-white text-center w-full">
    <div class="px-5 py-0.5 inline-block rounded-b-lg bg-brand-primary">
      <span class="text-xl uppercase">Option Control Test Mode</span>
    </div>
  </div>
</template>
